import React, { FC } from 'react'
import { colors } from '@/styles/colors'
import getWidthOrHeight from '@/processes/getWidthOrHeight'
import { IconProps } from '@/types/svgTypes'
import Svg from './Svg'

const Floor0Icon: FC<IconProps> = ({ width = 21, height, variant = 'gray30' }) => {
  const { h, w } = getWidthOrHeight(width, height)
  const fillColor = colors[variant]

  return (
    <Svg
      style={{ width: w, height: h }}
      viewBox="0 0 21 21"
    >
      <g clipPath="url(#clip0_820_50661)">
        <path
          d="M9.94216 14.6244C9.94216 15.3803 9.71248 15.9718 9.18748 16.3005C8.69529 16.662 7.90779 16.7934 6.79216 16.7934H4.56091V9.36619C5.34841 9.30047 6.03748 9.23474 6.6281 9.23474C7.64529 9.23474 8.39998 9.39906 8.85935 9.69483C9.31873 9.99061 9.54841 10.4836 9.54841 11.1408C9.54841 11.4038 9.5156 11.6338 9.38435 11.8967C9.31873 12.1268 9.15466 12.3239 8.9906 12.4883C8.82654 12.6526 8.62966 12.7512 8.39998 12.8498C9.41716 13.1455 9.94216 13.7371 9.94216 14.6244ZM6.72654 15.7089C7.31716 15.7089 7.74373 15.6432 7.97341 15.446C8.2031 15.2488 8.33435 14.9859 8.33435 14.5915C8.33435 13.8357 7.87498 13.507 6.8906 13.507H6.07029V15.7418H6.72654V15.7089ZM8.00623 11.2394C8.00623 10.9108 7.87498 10.6807 7.6781 10.5493C7.48123 10.385 7.1531 10.3192 6.69373 10.3192C6.52966 10.3192 6.43123 10.3192 6.33279 10.3192C6.26716 10.3192 6.16873 10.3192 6.1031 10.3521V12.4225H6.85779C7.21873 12.4225 7.48123 12.2911 7.71091 12.0939C7.9406 11.9296 8.00623 11.6009 8.00623 11.2394ZM14.0437 13.8685V12.7183H16.7672V16.0704C16.6031 16.2347 16.4062 16.3991 16.1437 16.5305C15.8812 16.6948 15.5531 16.7606 15.1922 16.8592C14.7984 16.9249 14.4375 16.9906 14.0437 16.9906C13.289 16.9906 12.6328 16.8263 12.1406 16.5305C11.6484 16.2019 11.2547 15.7418 10.9594 15.1502C10.6968 14.5587 10.5656 13.8685 10.5656 13.0469C10.5656 12.2253 10.7297 11.5352 10.9922 10.9437C11.2547 10.3521 11.6812 9.92488 12.239 9.59624C12.7969 9.2676 13.4203 9.13615 14.2078 9.13615C14.6015 9.13615 14.9953 9.20187 15.389 9.33333C15.75 9.46479 16.0453 9.59624 16.2422 9.79342C16.4718 9.99061 16.5703 10.1549 16.5703 10.3521C16.5703 10.4836 16.5375 10.615 16.4062 10.7465C16.275 10.9108 16.1765 11.0751 16.0125 11.1737C15.6844 10.9108 15.4218 10.7136 15.1593 10.5822C14.8968 10.4507 14.5687 10.4178 14.2078 10.4178C13.5515 10.4178 12.9937 10.6479 12.6328 11.0751C12.2719 11.5352 12.075 12.1596 12.075 13.0469C12.075 13.9343 12.2719 14.6244 12.6328 15.0845C12.9937 15.5446 13.5187 15.7746 14.2078 15.7746C14.5359 15.7746 14.7984 15.7418 15.0281 15.6103C15.0937 15.5775 15.225 15.5446 15.2906 15.446V13.8357H14.0437V13.8685Z"
          fill={fillColor}
        />
        <path
          d="M10.5 1.9061L1.64062 7.19718L1.67344 19.3239L18.3422 19.3568C18.9 19.3568 19.3266 18.9296 19.3266 18.3709V7.23005L10.5 1.9061ZM10.5 0L21 6.30986L20.9672 19.0282C20.9672 20.1127 20.0813 21 18.9984 21H0V6.277L10.5 0Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_820_50661">
          <rect
            width="21"
            height="21"
            fill={fillColor}
          />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default Floor0Icon
